export const environment = {
  production: false,
  isMockEnabled: true, // You have to switch this, when your real back-end is done
  authTokenKey: 'authce9d77b308c149d5992a80073637e4d5',
  // baseUrl: 'http://localhost:8034/api',
  baseUrl: 'https://dash.connectxpert.com.au/api',
  micrositeApiUrl: 'https://helathinsurancefind.com.au/api'
};
